import React, { Component } from 'react';
import {
  createNavigator,
  SwitchRouter,
  SceneView
} from "@react-navigation/core";
import {
  createBrowserApp,
  Link
} from "@react-navigation/web";


import {createStore} from 'redux';
import {Provider} from 'react-redux';
import AsyncStorage from '@callstack/async-storage';

import Login from "./pages/login/";
import Users from "./pages/users/";
import Inventory from "./pages/inventory/";
import Config from "./pages/config/";
import Orders from "./pages/orders/";
import Tracker from "./pages/tracker/";
import Wallet from "./pages/wallet/";
import ProductRequests from "./pages/productRequests/";
import Privacy from "./pages/privacy/";

const initialState = {
   user:  [],
   userid: null
}

const reducer = (state=initialState, action) => 
{

  switch(action.type)
  {   
      case 'SET_USER':
        return { ...state, user: action.payload.user, userid: action.payload.userid}
        break;
  }

  return state;
}

const store = createStore(reducer); 


Login.path = "";
Login.navigationOptions = {
  title: "EasySuki",
  linkName: "Login Page"
};

Users.path = "users";
Users.navigationOptions = {
  title: "EasySuki",
  linkName: "Users Page"
};

Inventory.path = "inventory";
Inventory.navigationOptions = {
  title: "EasySuki",
  linkName: "Inventory Page"
};

Config.path = "config";
Config.navigationOptions = {
  title: "EasySuki",
  linkName: "Config Page"
};

Orders.path = "orders";
Orders.navigationOptions = {
  title: "EasySuki",
  linkName: "Orders Page"
};

Tracker.path = "tracker";
Tracker.navigationOptions = {
  title: "EasySuki",
  linkName: "Tracker Page"
};

Wallet.path = "wallet";
Wallet.navigationOptions = {
  title: "EasySuki",
  linkName: "Wallet Page"
};

ProductRequests.path = "productRequests";
ProductRequests.navigationOptions = {
  title: "EasySuki",
  linkName: "Product Requests Page"
};

Privacy.path = "privacy";
Privacy.navigationOptions = {
  title: "EasySuki",
  linkName: "Privacy Page"
};

class AppView extends React.Component {
  render() {
    const { descriptors, navigation } = this.props;
    const activeKey = navigation.state.routes[navigation.state.index].key;
    const descriptor = descriptors[activeKey];
    
    return (
      <Provider store={store}>
        <SceneView
          component={descriptor.getComponent()}
          navigation={descriptor.navigation} />
      </Provider>
    );
  }
}

const AppNavigator = createNavigator(
  AppView,
  SwitchRouter({
    Login,
    Users,
    Inventory,
    Config,
    Orders,
    Tracker,
    Wallet,
    ProductRequests,
    Privacy
  }),
  {}
);

const App = createBrowserApp(AppNavigator);

export default App;